<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
    <g fill-rule="nonzero">
      <path
        d="M.5 3.375h9.625v1.5c0 .551.448 1 1 1h1.25c.552 0 1-.449 1-1v-1.5H20.5a.375.375 0 1 0 0-.75h-7.125v-1.5c0-.551-.448-1-1-1h-1.25c-.552 0-1 .449-1 1v1.5H.5a.375.375 0 1 0 0 .75zM20.5 10.125H7.125v-1.5c0-.552-.449-1-1-1h-1.25c-.551 0-1 .448-1 1v1.5H.5a.375.375 0 1 0 0 .75h3.375v1.5c0 .552.449 1 1 1h1.25c.551 0 1-.448 1-1v-1.5H20.5a.375.375 0 1 0 0-.75zM20.5 17.625h-8.375v-1.5c0-.552-.448-1-1-1h-1.25c-.552 0-1 .448-1 1v1.5H.5a.375.375 0 1 0 0 .75h8.375v1.5c0 .552.448 1 1 1h1.25c.552 0 1-.448 1-1v-1.5H20.5a.375.375 0 0 0 0-.75z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AbonnementIcon'
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

g {
  fill: $primary;
}
</style>
